import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/fonts.css';
import './styles/globals.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@govbr-ds/core/dist/core.min.css';
import { AuthProvider } from './hooks/useAuth/useAuth';
import { BrowserRouter } from 'react-router-dom';
import { environment } from './environment/environment';

const GOOGLE_ANALYTICS_IDS: Record<string, string> = {
  pro: 'G-PY6DKNLZ27',
};

const loadGoogleAnalytics = (): void => {
  const analyticsId = GOOGLE_ANALYTICS_IDS[environment.environment];
  if (!analyticsId) return;

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
  document.head.appendChild(gtagScript);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${analyticsId}');
  `;
  document.head.appendChild(inlineScript);
};

loadGoogleAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
